import breakpoints from './breakpoints';

import fallbackLogo from './images/logo.svg';
import ChevronDown from './svgs/chevron-down.svg';

// Shared default theme object
// each site's theme will get this automatically and can be overridden
// in the site's theme object

const DefaultTheme = {
  accountMenuBackground: '#f8f8f8',
  accountMenuItemBorder: '#CD6598',
  accountMenuItemCurrentBackground: '#ffffff',
  breakpoints,
  button: {
    borderRadius: '0',
    borderRadiusInner: '0',
    borderStyle: 'solid',
    borderStyleHover: '',
    borderStyleInner: 'none',
    borderStyleInnerHover: '',
    borderWidth: '1px',
    borderWidthInner: '0',
    boxShadow: 'none',
    padding: '0.625rem',
    paddingInner: '0',
    primary: {
      background: '#666666',
      backgroundActive: '#000000',
      backgroundDisabled: '#444444',
      backgroundHover: '#555555',
      borderColor: 'transparent',
      borderColorActive: '',
      borderColorHover: '',
      borderColorInner: 'transparent',
      borderColorInnerActive: '',
      borderColorInnerHover: '',
      textColor: '#ffffff',
      textColorActive: '',
      textColorHover: '',
    },
    secondary: {
      background: '#666666',
      backgroundActive: '#000000',
      backgroundDisabled: '#444444',
      backgroundHover: '#555555',
      borderColor: 'transparent',
      borderColorActive: '',
      borderColorHover: '',
      borderColorInner: 'transparent',
      borderColorInnerActive: '',
      borderColorInnerHover: '',
      textColor: '#ffffff',
      textColorActive: '',
      textColorHover: '',
    },
    tertiary: {
      background: '#666666',
      backgroundActive: '#000000',
      backgroundDisabled: '#444444',
      backgroundHover: '#555555',
      borderColor: 'transparent',
      borderColorActive: '',
      borderColorHover: '',
      borderColorInner: 'transparent',
      borderColorInnerActive: '',
      borderColorInnerHover: '',
      textColor: '#ffffff',
      textColorActive: '',
      textColorHover: '',
    },
    textTransform: 'none',
  },
  colors: {
    accordion: {
      color: '#FFFFFF',
      background: '#e8e8e8',
      backgroundHover: '#d1d1d1',
    },
    background: '#ffffff',
    badge: '#777777',
    badgeText: '#ffffff',
    border: '#CD6598',
    callout: '#C4E6FF',
    cardBackgroundHover: '#666666',
    brandPrimary: '#CD6598',
    brandSecondary: '#FEDBD4',
    breadcrumbLinkColor: '#00000',
    cardBackground: '#333333',
    cardText: '#ffffff',
    carouselBullet: '#bbbbbb',
    carouselBulletHover: '#666666',
    comparisonChart: {
      alternateRowShade: '#bbbbbb',
      cellBorder: '#bbbbbb',
      highlightColumn: {
        primary: {
          backgroundColor: '#CD6598',
          color: '#FFFFFF',
        },
        secondary: {
          backgroundColor: '#AD4578',
          color: '#CD6598',
        },
        tertiary: {
          backgroundColor: '#FD95C8',
          color: '#FFFFFF',
        },
      },
      mobileSubhead: {
        backgroundColor: '#FEDBD4',
      },
    },
    contentCard: {
      primary: {
        backgroundColor: '#CD6598',
        border: 'none',
        color: '#FFFFFF',
      },
      quaternary: {
        backgroundColor: '#FFFFFF',
        border: '#FFFFFF',
        color: '#FEDBD4',
      },
      secondary: {
        backgroundColor: '#FFFFFF',
        border: '#000000',
        color: '#CD6598',
      },
      tertiary: {
        backgroundColor: '#FEDBD4',
        border: 'none',
        color: '#FFFFFF',
      },
    },
    defaultFont: '#333333',
    headline: '#444444',
    hero: {
      mobileHeadlineColor: '#CD6598',
      primary: {
        color: '#CD6598',
      },
      quaternary: {
        color: '#EEEBD4',
      },
      secondary: {
        color: '#FEDBD4',
      },
      tertiary: {
        color: '#FFFBD4',
      },
    },
    iconButtonBackgroundHover: '#666666',
    iconButtonFill: '#222222',
    inputBorder: '#333333',
    inputFontColor: '#333333',
    link: '#0000ee',
    linkHover: '#0000ee',
    navSearchAllResultsColor: '#646464',
    navSearchHitsContainerText: '#2e2e2e',
    onSaleRed: '#C10000',
    searchBorder: '#CD6598',
    searchFormHitBorderColor: '#d4d4d4',
    searchInput: '#646464',
    searchInputBackground: '#ffffff',
    supportArticleLink: '#5d5d5d',
    tagBackground: '#333333',
    tagBackgroundHover: '#666666',
    typography: {
      brandContrast: '#333333',
    },
  },
  footer: {
    backgroundColor: '#ffffff',
    fontColor: '#000000',
    socialIconFill: '#666666',
    socialIconFillHover: '#333333',
  },
  headerBackground: '#444444',
  headline: '#444444',
  hero: {
    fontColor: '#ffffff',
    span: {
      textTransform: 'none',
    },
  },
  images: {
    logo: fallbackLogo,
    pagePreviewFallbackImage: fallbackLogo,
  },
  logoHeight: '64px',
  name: 'Default Theme',
  navigation: {
    DownArrow: ChevronDown,
    NavDesktopMenuItemFontSize: '1rem',
    downArrowSize: 22,
    downArrowSpacing: '0.25rem',
    fontWeight: 'normal',
    mainItemTextTransform: 'inherit',
    subSectionHeadingTextTransform: 'inherit',
  },
  notificationBanner: {
    background: '#CD6598',
    text: '#FFF',
  },
  productCard: {
    backgroundColor: '#ffffff',
    borderColor: 'transparent',
    borderColorHover: '#eeeeee',
    boxShadow: 'none',
    boxShadowHover: '0 0 30px 0 rgba(153, 153, 153, 0.1)',
    inlineRatingsMarginBottom: '0.9375rem',
    priceColor: 'revert',
    titleColor: 'inherit',
    titleColorHover: '#000000',
    titleFontWeight: 'normal',
    titleTextTransform: 'inherit',
  },
  quizCard: {
    recommendationBackgroundColor: 'transparent',
  },
};

export { DefaultTheme };
